import { fmtTime } from '../format';

export function EmptyOverlay(p: { onRecord: () => void; onImport: () => void; canRecord: boolean }) {
  return (
    <div className="overlay">
      <h2>Joue quelque chose</h2>
      <p>
        On écoute, on trouve le tempo, et on remet chaque note en place. Tu pourras tout ajuster
        ensuite.
      </p>
      <div className="row">
        <button className="btn rec" onClick={p.onRecord} disabled={!p.canRecord}>
          ● Enregistrer au micro
        </button>
        <button className="btn" onClick={p.onImport}>
          Importer un fichier…
        </button>
      </div>
      <div className="hint">
        WAV, MP3, M4A, FLAC, OGG, WebM · le micro demande une page en HTTPS
        {p.canRecord ? '' : ' — indisponible sur ce navigateur'}
      </div>
    </div>
  );
}

export function RecordingOverlay(p: { elapsed: number; level: number; onStop: () => void }) {
  const bars = 15;
  return (
    <div className="overlay scrim">
      <div className="reclabel">
        <span className="dot" />
        Enregistrement…
      </div>
      <div className="bigtime">{fmtTime(p.elapsed)}</div>
      <div className="meter" aria-hidden="true">
        {Array.from({ length: bars }, (_, i) => {
          const w = 0.45 + 0.55 * Math.sin((i / bars) * Math.PI);
          const h = Math.max(8, Math.min(100, p.level * 130 * w));
          return <span key={i} style={{ height: `${h}%` }} />;
        })}
      </div>
      <button className="btn primary" onClick={p.onStop}>
        ■ Arrêter
      </button>
      <div className="hint">Garde l’écran allumé pendant l’enregistrement.</div>
    </div>
  );
}

export function BusyOverlay(p: { label: string }) {
  return (
    <div className="overlay scrim">
      <div className="spinner" />
      <div style={{ fontSize: 14, fontWeight: 600 }}>{p.label}</div>
      <div className="hint">Le traitement se fait sur le serveur.</div>
    </div>
  );
}
